import script from "./dvr.vue?vue&type=script&setup=true&lang=js"
export * from "./dvr.vue?vue&type=script&setup=true&lang=js"

import "./dvr.vue?vue&type=style&index=0&id=1bfe6700&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bfe6700"]])

export default __exports__